import {createSlice} from "@reduxjs/toolkit";

const INIT_STATE = {
    open: false,
    loading: false,
    dataCreation: null
};

const route = 'modules/driverPerformance/views/cases/modals/viewCreationPanel/redux/slice';

//Slice
const driverPerformanceCasesTabViewCreationPanelRedux = createSlice({
    name: "driverPerformance/viewCreationPanel",
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? {...state, ...action.payload} : INIT_STATE;
        },
        openModalViewCreationPanel: (state, action) => {
            state.open = action.payload.open;
            state.dataCreation = action.payload.dataCreation;
        }
    },
});

// Extract and export the action creators object and the reducer
export const {actions, reducer} = driverPerformanceCasesTabViewCreationPanelRedux;

// Extract and export each action creator by name
export const {openModalViewCreationPanel, reset} = actions;

// Export the reducer, either as a default or named export
export default reducer;
